import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { getParameterByName } from '../../../js_assets/getParameterByName'
import { publishable_api_key_moyasar, api_url } from '../../../js_assets/ConfigApp'
import { CreateSubscriptionSchedule, FetchPaymentUser } from '../../../action/CreateSubscriptionSchedule'
import { isSafari } from 'react-device-detect'
import './style.css'
import LoadingIcon from '../../LoadingIcon';
import ServerModal from '../../ServerModal';
const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    ButtonSearch: {
        backgroundColor: '#007bff',
        color: 'white',
        '&:hover': {
            background: '#007bff'
        }
    },
    ButtonShop: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        },
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
        margin: theme.spacing.unit,
        padding: '8px 15px'
    },
    ButtonCode: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        },
        fontFamily: [
            'DIN-NEXT™-ARABIC-BOLD',
        ].join(','),
        margin: theme.spacing.unit,
        padding: '4px',
        fontSize: 12,
        marginBottom: '20px'
    },
    tab: {
        flexGrow: 1,
        marginTop: 2,
        backgroundColor: '#f7faea'

    },
    iocns: {
        fontSize: 18
    },
    ratingContainer: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        paddingRight: 10,
        flex: 1,
    },
    dividerrating: {
        width: 1,
        height: 28,
        margin: 4,
    },
    iconButtonRating: {
        padding: 10,
    },
    divpadding: {
        padding: '5%'
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '100%',
        opacity: '0.9',
        borderRadius: '3px',
        backgroundColor: '#b1d236',
    },
    PaymentCardDiv: {
        margin: '0px 3%'
    }
    , centergif: {
        position: 'fixed',
        top: '65%',
        left: '5%',

        marginLeft: '35px'

    }



});

class WebViewPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amount_required: 0,
            isLoading: false,
            followUp_Schedule_Id: 0,
            trainer_Id: 0,
            userId: 0



        };


    }



    componentDidMount() {


        this.check_payment();
    }



    check_payment = () => {
        let id = getParameterByName("id")
        let status = getParameterByName("status")
        let message = getParameterByName("message")
        if (id != null) {
            if (status === "paid") {

                this.setState({ isLoading: true })
                let payment_model = {
                    payment_Id: id,
                    UserId: parseInt(getParameterByName("userId")),
                    payment_Amount: parseFloat(getParameterByName("amount_required") / 100)
                }

                let Subscription_Schedule_Model = {
                    UserID: parseInt(getParameterByName("userId")),
                    trainer_Id: parseInt(getParameterByName("trainer_Id")),
                    followUp_Schedule_Id: parseInt(getParameterByName("followUp_Schedule_Id")),
                    subscription_Price: parseFloat(getParameterByName("amount_required")),
                    original_Subscription_Price: 0,
                    payment_Transaction_Id: id,
                    subscription_Current: true,
                    Subscription_Is_Free: false,
                    discount_Code_Id: 0
                }

                FetchPaymentUser(payment_model).then(result => {

                    if (result.status === "paid") {
                        CreateSubscriptionSchedule(Subscription_Schedule_Model).then((rep) => {
                            if (rep == true) {

                                this.setState({ isLoading: false })


                                alert("شكرا لإشتراكك", "حمل التطبيق لمحادثة المختص وإستلام نظامك 👍🏻")

                            }
                        }).catch(e => {
                            alert(e)
                        });

                    } else {

                        this.setState({ isLoading: false })
                        alert(" هناك خطاء في تحقق من المبلغ", message)
                        this.props.history.push(`/WebViewPayment?amount_required=${process.env.NODE_ENV !== "development" ? 1 * 100 : parseInt(getParameterByName("amount_required") * 100)}&followUp_Schedule_Id=${getParameterByName("followUp_Schedule_Id")}&trainer_Id=${getParameterByName("trainer_Id")}&userId=${getParameterByName("userId")}`);
                    }
                })
            }
            else {

                this.setState({ isLoading: false })
                alert(" هناك خطاء   status not  paid ", message)
                this.props.history.push(`/WebViewPayment?amount_required=${process.env.NODE_ENV !== "development" ? 1 * 100 : parseInt(getParameterByName("amount_required") * 100)}&followUp_Schedule_Id=${getParameterByName("followUp_Schedule_Id")}&trainer_Id=${getParameterByName("trainer_Id")}&userId=${getParameterByName("userId")}`);
            }

        } else {
            window.location.href = `https://api.protein40app.xyz/CheckoutLandingPage.html?amount=${parseInt(process.env.NODE_ENV !== "development" ? 1 * 100 : parseInt(getParameterByName("amount_required") * 100))}&followUp_Schedule_Id=${getParameterByName("followUp_Schedule_Id")}&trainer_Id=${getParameterByName("trainer_Id")}&userId=${getParameterByName("userId")}`
        }


    }

    render() {


        return (

            <div >
                {this.state.isLoading && <LoadingIcon />}
                <ServerModal open={false} />
                {/* 
                <iframe src='https://api.protein40app.xyz/Checkout.html?amount=100'
                    title="Checkout"
                    onLoad={e => this.check_payment(e.currentTarget.srcdoc)}
                    frameborder="0"
                    marginheight="50%"
                    marginwidth="0"
                    width="100%"
                    height="800px"
                    scrolling="auto" /> */}
            </div >
        )
    }


}
WebViewPayment.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WebViewPayment);